// extracted by mini-css-extract-plugin
export var baseButton = "_pm-0";
export var controlsArrowKeys = "_pm-1";
export var controlsResetButton = "_pm-2";
export var lightGameButton = "_pm-4 _pm-0";
export var playAgainButton = "_pm-5 _pm-0";
export var startGameButton = "_pm-3 _pm-0";